import { render, staticRenderFns } from "./query.vue?vue&type=template&id=70c7d0cc&scoped=true&"
import script from "./query.vue?vue&type=script&lang=ts&"
export * from "./query.vue?vue&type=script&lang=ts&"
import style0 from "./query.vue?vue&type=style&index=0&id=70c7d0cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7d0cc",
  null
  
)

export default component.exports